const THANKS_PAGE_PATH = "/contact/complete/";
let isMailSentHandlerBound = false;

type InitCallback = (form: HTMLFormElement) => void;
type Wpcf7FormElement = HTMLFormElement & { wpcf7?: unknown };

declare global {
  interface Window {
    wpcf7?: {
      init?: InitCallback;
      initForm?: InitCallback;
    };
  }
}

const handleMailSent = () => {
  window.location.assign(THANKS_PAGE_PATH);
};

const allowNativeScrollOnTextareas = () => {
  const textareas =
    document.querySelectorAll<HTMLTextAreaElement>(".wpcf7 textarea");

  textareas.forEach((textarea) => {
    textarea.dataset.lenisPrevent = "true";
    textarea.dataset.lenisPreventWheel = "true";
    textarea.dataset.lenisPreventTouch = "true";
  });
};

const ensureContactFormInitialized = (retryCount = 0): void => {
  const forms = document.querySelectorAll<HTMLFormElement>(".wpcf7 form");
  if (!forms.length) return;

  allowNativeScrollOnTextareas();

  const initForm = window.wpcf7?.init ?? window.wpcf7?.initForm;
  if (typeof initForm !== "function") {
    if (retryCount < 5) {
      window.setTimeout(() => {
        ensureContactFormInitialized(retryCount + 1);
      }, 100);
    }
    return;
  }

  forms.forEach((form) => {
    const cf7Form = form as Wpcf7FormElement;

    // CF7本体がすでに初期化済みのフォームは再初期化しない
    if (cf7Form.wpcf7) return;

    initForm(cf7Form);
  });
};

const bindMailSentHandler = () => {
  if (isMailSentHandlerBound) return;

  document.addEventListener("wpcf7mailsent", handleMailSent);
  isMailSentHandlerBound = true;
};

export const initContactPageEffects = () => {
  // DOMContentLoaded で CF7 本体の初期化が走る前に呼び出されると二重初期化になるため、
  // タスクを遅延させて CF7 側の初期化完了後に不足分のみ初期化する
  window.setTimeout(() => {
    ensureContactFormInitialized();
  }, 0);
  bindMailSentHandler();
};

export {};
